import { EmploymentType } from '@thesavingsgroup/enums/EmploymentType';

export const unemployedTypes: EmploymentType[] = [
  EmploymentType.DISABILITY,
  EmploymentType.HOMEMAKER,
  EmploymentType.RETIRED,
  EmploymentType.STUDENT,
  EmploymentType.OTHER,
];
